import { Box, Button, Chip, FormHelperText, Grid, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Api from '../../Api';
import {
    IImportFormSection, IMaterial
} from '../../interfaces';

export const ImportFormSection: React.SFC<IImportFormSection> = ({
    entity,
    onUpdate,
    onImported,
    ...props
}: IImportFormSection) => {

    const [uploading, setUploading] = useState(false);
    const [errors, setErrors] = useState<string[]>();
    const [warnings, setWarnings] = useState<string[]>();


    const onDownloadTemplate = () => {
        Api.Materials.getImportTemplate().then((response: any) => response.blob())
            .then((blob) => {

                const filename = `import_material_template_V3.xlsx`;

                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );

                const link: HTMLAnchorElement = document.createElement('a');

                link.href = url;
                link.setAttribute(
                    'download',
                    filename,
                );
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
            });
    }

    const onChangeFile = async (e: React.ChangeEvent<HTMLInputElement>) => {

        if (e.target.files) {

            setUploading(true);
            setErrors([]);
            setWarnings([]);

            let formData = new FormData();
            formData.append("entityId", entity.id);
            formData.append("entityType", entity.type);
            formData.append("File", e.target.files[0]);

            Api.Materials.import(formData).then((data: any) => {

                if (data.errors)
                    setErrors(data.errors as string[]);

                if (data.warnings)
                    setWarnings(data.warnings as string[]);

                if (data.materials)
                    onImported(data.materials as IMaterial[]);
                else { console.log("no materials"); }

                setUploading(false);
                e.target.value = "";

            });

        }
    }

    useEffect(() => {
        console.log("entity loaded", entity);
    }, [entity])

    return (
        <Grid item textAlign="center" sx={{ p: 0.5 }}>

            <Button
                sx={{my:4} }
                variant="contained"
                component="label"
                size="large"
                disabled={uploading}
            >
                Upload
                <input
                    hidden
                    accept=".csv"
                    onChange={onChangeFile}
                    type="file"

                />
            </Button>

            {
        errors &&
            errors.map(err => {
                return <Box sx={{ my: 1 }}><Chip size="small" color="error" label={err} sx={{ whiteSpace: "no-wrap" }} /></Box>
            })
    }

            {
        warnings &&
            warnings.map(warning => {
                return <Box sx={{ my: 1 }}><Chip size="small" color="warning" label={warning} sx={{ whiteSpace: "no-wrap" }} /></Box>
            })
    }


            <br />
            <Button
                variant="outlined"
                size="small"
                color="primary"
                sx={{ mr: 1, mt: 2 }}
                onClick={onDownloadTemplate}
            >
                Download Template
            </Button>
            <FormHelperText className="text-center" sx={{ my: 1, maxWidth: "320px", mx: "auto" }} > <small>This template contains instructions for use. It must be saved as csv before uploading.</small></FormHelperText>

        </Grid >
    );
}
